import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { ApiService } from '../services/api.service';



@Component({

  selector: 'app-employee-profile-fui',

  templateUrl: './employee-profile-fui.component.html',

  styleUrls: ['./employee-profile-fui.component.scss']

})

export class EmployeeProfileFuiComponent implements OnInit {

  employees: any[] = [];

  selectedEmpId: number | null = null;

  selectedEmployee: any = null;

  loading = false;

  activeLoanPlan: any = null;

  employeeSearch: string = '';



  constructor(

    private apiService: ApiService,

    private router: Router

  ) {}



  ngOnInit(): void {

    this.loadEmployees();

  }



  loadEmployees(): void {

    this.apiService.getEmplyees().subscribe(res => {

      const data: any = res || {};

      this.employees = data.employees || data || [];

    });

  }



  onEmployeeChange(): void {

    if (!this.selectedEmpId) {

      this.selectedEmployee = null;

      this.activeLoanPlan = null;

      return;

    }

    this.loading = true;

    this.apiService.getEmplyeeDetailsById(this.selectedEmpId).subscribe(

      res => {

        const data: any = res || {};

        this.selectedEmployee = data;

        this.loadLoanPlan();

      },

      _ => {

        this.loading = false;

      }

    );

  }



  private loadLoanPlan(): void {

    if (!this.selectedEmpId) {

      this.activeLoanPlan = null;

      this.loading = false;

      return;

    }

    this.apiService.getPayrollLoanPlan(this.selectedEmpId).subscribe(

      data => {

        const list = data || [];

        this.activeLoanPlan = Array.isArray(list) && list.length ? list[0] : null;

        this.loading = false;

      },

      _ => {

        this.activeLoanPlan = null;

        this.loading = false;

      }

    );

  }



  getInitials(employee: any): string {

    if (!employee) { return ''; }

    const name = employee.employeeName || employee.name || '';

    const parts = name.split(' ').filter((p: string) => !!p);

    if (parts.length === 0) { return ''; }

    if (parts.length === 1) { return parts[0].charAt(0).toUpperCase(); }

    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();

  }



  get filteredEmployees(): any[] {

    const term = (this.employeeSearch || '').toLowerCase().trim();

    if (!term) {

      return this.employees;

    }

    return this.employees.filter(e => {

      const id = e.employeeId != null ? String(e.employeeId) : '';

      const name = (e.employeeName || e.name || '').toLowerCase();

      return id.includes(term) || name.includes(term);

    });

  }



  getLoanRemainingMonths(): number | null {

    if (!this.activeLoanPlan || this.activeLoanPlan.totalMonths == null || this.activeLoanPlan.monthsPaid == null) {

      return null;

    }

    return this.activeLoanPlan.totalMonths - this.activeLoanPlan.monthsPaid;

  }



  selectEmployeeFromSearch(e: any): void {

    if (!e || e.employeeId == null) {

      return;

    }

    this.selectedEmpId = e.employeeId;

    this.employeeSearch = `${e.employeeId} - ${e.employeeName || e.name || ''}`.trim();

    this.onEmployeeChange();

  }



  openPayrollProfiles(): void {

    if (!this.selectedEmployee || !this.selectedEmployee.employeeId) {

      return;

    }

    this.router.navigate(['/hr-profiles'], {

      queryParams: { empId: this.selectedEmployee.employeeId }

    });

  }



  openPayslips(): void {

    if (!this.selectedEmployee || !this.selectedEmployee.employeeId) {

      return;

    }

    this.router.navigate(['/payslips'], {

      queryParams: { empId: this.selectedEmployee.employeeId }

    });

  }



  openHrEmployeeForm(): void {

    if (!this.selectedEmployee || !this.selectedEmployee.employeeId) {

      return;

    }

    this.router.navigate(['/hr-employee-form'], {

      queryParams: { empId: this.selectedEmployee.employeeId }

    });

  }

}

